import getDefaultStyle from '../css/defaultStyle';
import merge from 'lodash-es/merge';
import get from 'lodash-es/get';

export function getDefaultControlStyle(control) {
  const design = get(control,['options','lookAndFeel','controlsDesign'],'classic');
  if (!getDefaultControlStyle[control.designMode]) {
    getDefaultControlStyle[control.designMode]={};
  }

  if (!getDefaultControlStyle[control.designMode][design]) {
    // var dur = !control.isLayoutMode ? '0.3s' : '0s';
    getDefaultControlStyle[control.designMode][design] = {
      normal: merge({}, getDefaultStyle(), {
        position: 'absolute',
        cursor: 'pointer',
        transitionProperty: 'all',
        transitionDuration: '${schemeAnimationDuration}',
        transitionTimingFunction: 'ease',
        transitionDelay: '0s',
        top: '8px',
        left: '8px',
        width: '112px',
        height: '16px',
        margin: '0px',
        display: 'inline-block',
        userSelect: 'none',
      }),
      body: {
        normal: merge({}, getDefaultStyle(), {
          display: 'block',
          position: 'absolute',
          top: '0px',
          right: '0px',
          bottom: '0px',
          left: '0px',
          width: '100%',
          height: '100%',
          margin: '0px',
          whiteSpace: 'nowrap',
          overflow: 'visible',
        }),
        hover: {},
        top: {
          textAlign: 'center',
        },
        right: {},
        bottom: {
          textAlign: 'center',
        },
        left: {
          textAlign: 'right',
        },
      },
      hover: {},
      icon: {
        normal: merge({}, getDefaultStyle(), {
          transformOrigin: 'center',
          transitionProperty: 'all',
          transitionDuration: '${schemeAnimationDuration}',
          transitionTimingFunction: 'ease',
          transitionDelay: '0s',
          boxSizing: 'border-box',
          // backgroundColor: '${schemeBackground}',
          backgroundColor: '${schemeForeground}',
          borderStyle: 'solid',
          // borderColor: '${schemeShade}',
          borderColor: '#888',
          borderWidth: design=='classic'?'2px':0,
          borderRadius: design=='classic'?'3px':'1px',
          // boxShadow: '0px 2px 4px rgba(0,0,0,0.4), 0 -12px 20px ${schemeShade} inset,  0 2px 3px #ffffff inset',
          boxShadow: design=='classic'?
            '0px 2px 4px rgba(0,0,0,0.4), 0 -12px 20px rgba(0,0,0,0.4) inset,  0 2px 3px rgba(0,0,0,0.5) inset'
            :'0px 0px 4px rgba(0,0,0,0.4)',
          display: 'inline-block',
          width: 'auto',
          height: '100%',
        }),
        hover: {
          // backgroundColor: '${schemeBackgroundHover}',
          // boxShadow: '0px 2px 2px rgba(0,0,0,0.4), 0 -8px 20px ${schemeShade} inset,  0 2px 3px #ffffff inset',
          boxShadow: design=='classic'?
            '0px 0px 5px 2px ${schemeShade}, 0 -12px 20px rgba(0,0,0,0.3) inset,  0 2px 3px rgba(0,0,0,0.4) inset'
            :'0px 0px 5px 2px ${schemeShade}',
        },
        focused: {
          // backgroundColor: '${schemeBackgroundHover}',
          // boxShadow: '0px 2px 2px rgba(0,0,0,0.4), 0 -8px 20px ${schemeShade} inset,  0 2px 3px #ffffff inset',
          boxShadow: design=='classic'?
            '0px 0px 5px 2px ${schemeShade}, 0 -12px 20px rgba(0,0,0,0.3) inset,  0 2px 3px rgba(0,0,0,0.4) inset'
            :'0px 0px 5px 2px ${schemeShade}',
        },
        top: {},
        right: {},
        bottom: {},
        left: {},
      },
      iconPath: {
        normal: {
          // fill: '${schemeForeground}',
          fill: '${schemeBackground}',
          transitionProperty: 'opacity',
          transitionDuration: '${schemeAnimationDuration}',
          transitionTimingFunction: 'ease',
          transitionDelay: '0s',
          opacity: 0,
        },
        checked: {
          opacity: 1,
        },
      },
      label: {
        normal: merge({}, getDefaultStyle(), {
          transitionProperty: 'all',
          transitionDuration: '${schemeAnimationDuration}',
          transitionTimingFunction: 'ease',
          transitionDelay: '0s',
          display: 'none',
          padding: '${schemePaddingTop} calc(${schemeFontSize} / 2)',
          backgroundColor: 'transparent',
          color: '${schemeForeground}',
          textAlign: 'center',
          textShadow: design=='classic'?'0 2px 2px ${schemeShade}':'0 0px 4px ${schemeShade}',
          fontFamily: 'monospace',
          whiteSpace: 'nowrap',
          fontSize: '${schemeFontSize}',
          fontWeight: '${schemeFontWeight}',
          // height: 'calc(${schemePaddingTop} * 2 + ${schemeFontSize})',
          height: '100%',
          overflow: 'hidden',
        }),
        top: {
          display: 'block',
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)',
          bottom: '100%',
          padding: 'calc(${schemeFontSize} / 2)',
          height: 'auto',
        },
        right: {
          display: 'inline-block',
        },
        bottom: {
          height: 'auto',
          display: 'block',
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)',
          bottom: '100%',
          padding: 'calc(${schemeFontSize} / 2)',
          top: '100%',
        },
        left: {
          display: 'inline-block',
        },
      },
    };
  }

  return getDefaultControlStyle[control.designMode][design];
}

export function getDefaultControl() {
  if (!getDefaultControl.source) {
    getDefaultControl.source = document.createElement('div');
    getDefaultControl.source.classList.add('controls');
    getDefaultControl.source.innerHTML =
      '<div class="body"><span class="label"></span>' +
      '<svg class="icon" viewBox="0 0 24 24">' +
      // '<defs>' +
      // '  <filter id="f3" x="0" y="0" width="200%" height="200%">' +
      // '    <feOffset result="offOut" in="SourceAlpha" dx="20" dy="20" />' +
      // '    <feGaussianBlur result="blurOut" in="offOut" stdDeviation="10" />' +
      // '    <feBlend in="SourceGraphic" in2="blurOut" mode="normal" />' +
      // '  </filter>' +
      // '</defs>' +
      '<path fill="#000000" d="M9,20.42L2.79,14.21L5.62,11.38L9,14.77L18.88,4.88L21.71,7.71L9,20.42Z" />' + //filter="url(#f3)"
      '</svg>' +
      '<span class="label"></span></div>';
    getDefaultControl.source.setAttribute('tabindex', '0');
  }

  return getDefaultControl.source.cloneNode(true);
}
